export default "__VITE_ASSET__DWhvDFrs__"